<template>
  <div>
    <a
      v-if="isUmbracoContent"
      :href="link.url"
      target="_blank"
      rel="noopener"
      class="cta"
      :class="downloadBtnStyle"
      :aria-label="link.label"
      download
      @click="tryLogDownload">
      <font-awesome-icon :icon="downloadIcon"></font-awesome-icon>
      {{ label }}
    </a>
    <div v-else
         class="cta cta--download download"
         @click="downloadItem">
      <font-awesome-icon icon="cloud-download-alt"
                         size="lg">
      </font-awesome-icon>
      {{ label }}
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { addUserUsage } from "~/Scripts/resources/toolkitResource";

export default {
  name: "Download",
  components: {},
  props: {
    label: {
      type: String,
      default: "Download",
    },
    link: {
      required: true,
      type: Object,
      default: () => ( { label: "download", url: "#" } ),
      validator ( val ) {
        return (
          Object.prototype.hasOwnProperty.call( val, "label" )
          && Object.prototype.hasOwnProperty.call( val, "url" )
        );
      },
    },
    isUmbracoContent: {
      type: Boolean,
      required: false,
      default: true,
    },
    type: {
      type: String,
      default: "cloud",
      validator ( val ) {
        return ["file", "cloud"].includes( val );
      },
    },
    mimeType: {
      required: false,
      type: String,
      default: "application/octet-stream",
    },
    log: {
      type: Object,
      default: () => ( {} ),
      validator ( val ) {
        console.info( val );
        return ["title", "detail"].every( key => key in val );
      },
    },
  },
  data: () => ( {} ),
  computed: {
    downloadBtnStyle () {
      switch ( this.type ) {
        case "file": {
          return "cta__download--primary";
        }
        case "cloud":
        default: {
          return "cta__download";
        }
      }
    },
    downloadIcon () {
      switch ( this.type ) {
        case "file": {
          return ["fal", "file-download"];
        }
        case "cloud":
        default: {
          return "cloud-download-alt";
        }
      }
    },
  },
  methods: {
    downloadItem () {
      this.tryLogDownload();

      axios
        .get( this.link.url, { responseType: "blob" } )
        .then( response => {
          const blob = new Blob( [response.data], { type: this.mimeType } );
          const link = document.createElement( "a" );
          link.href = URL.createObjectURL( blob );
          link.download = this.link.label;
          link.click();
          URL.revokeObjectURL( link.href );
        } )
        .catch( console.error );
    },
    tryLogDownload () {
      const { title, detail } = this.log;
      if ( title && detail ) {
        try {
          console.info( addUserUsage( title, detail ) );
        } catch ( err ) {
          console.error( err );
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/index.less";
@import "../../Styles/common/buttons.less";

.download {
}
</style>
